import React, { PropsWithChildren, ReactNode } from 'react';
import { LeftPanelPageBaseStyle as S } from './LeftPanelPageBase.style';
import { LeftPanelPageBaseHeader } from './components/LeftPanelPageBaseHeader/LeftPanelPageBaseHeader';
import { LeftPanelPageBaseLeftComponent } from './components/LeftPanelPageBaseLeftComponent/LeftPanelPageBaseLeftComponent';

export const LeftPanelPageBase: React.FC<
  PropsWithChildren<{
    sideContent?: ReactNode;
    breadCrumbs?: 'hidden' | null;
    hideLeftPanel?: boolean;
    rightWidth?: 'normal' | 'wide';
  }>
> = ({ children, breadCrumbs, hideLeftPanel, rightWidth }) => {
  return (
    <S.Container>
      <LeftPanelPageBaseHeader {...{ breadCrumbs }} />
      <S.MainContentBox>
        {!hideLeftPanel && <LeftPanelPageBaseLeftComponent />}
        <S.RightContentBox>
          <S.RightContentScroll>
            <S.Scroll>
              <S.RightContent $rightWidth={rightWidth || 'normal'}>{children}</S.RightContent>
            </S.Scroll>
          </S.RightContentScroll>
        </S.RightContentBox>
      </S.MainContentBox>
    </S.Container>
  );
};
